
import Vue, {PropOptions} from 'vue'
import ChefCard from "~/components/index/chef-highlight/chef-card.vue";
import {ChefCardInterface} from "~/components/index/chef-highlight.vue";

export default Vue.extend({
  name: 'ChefReview',
  components: {ChefCard},
  props: {
    chef: {
      type: Object,
      required: true
    } as PropOptions<ChefCardInterface>
  },
  data(): {
    showChefScorePopup: boolean;
  } {
    return {
      showChefScorePopup: false
    }
  },
})
